import { useEffect } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

import { MY_CLEANINGS_MODALS } from "@typings/clientDashboard";

import { getSearchParamsFromURL } from "@services/GetSearchParamsFromURL";

import { useModalManager } from "@hooks/modal";

import { getContracts } from "@app/redux/profile";

export const useSetupCleaningChecklistQuery = () => {
  const history = useHistory();
  const contracts = useSelector(getContracts);
  const cleaningChecklistAvailable = contracts.some(
    i => i.get("cleaningChecklist").canBeFilled,
  );
  const { showModal } = useModalManager();

  useEffect(() => {
    if (!window?.location) return;
    if (contracts.size === 0) return;
    if (!cleaningChecklistAvailable) return;

    const queryParams = getSearchParamsFromURL(window.location.href);
    const startChecklistQuery = queryParams.get("setupCleaningChecklist");

    if (!startChecklistQuery) return;

    queryParams.delete("setupCleaningChecklist");

    history.replace({
      search: queryParams.toString(),
    });

    showModal(MY_CLEANINGS_MODALS.CHECKLIST_WARNING, {
      contracts,
    });
  }, [contracts]);
};
